import { economyConfig } from '../config/economyConfig';

/**
 * Player model (spec section 5).
 *
 * Kept as a plain serializable interface (no methods) so the whole GameState
 * round-trips through JSON for save/load and, later, for an authoritative
 * multiplayer server.
 *
 * Fields relating to parking lots / loans are declared now (per spec) but are
 * empty in Phase 1; later phases populate them.
 */
export interface Player {
  id: string;
  companyName: string;
  cash: number;
  companyValue: number;
  totalRevenue: number;
  totalExpense: number;
  totalProfit: number;
  reputation: number; // 0..100
  parkingLotIds: string[]; // ids into GameState.parkingLots (Phase 2+)
  marketShare: number; // 0..1
  loans: Loan[];
  researchPoints: number;
}

export interface Loan {
  id: string;
  principal: number;
  remaining: number;
  interestRate: number; // annual
}

export function createPlayer(
  id: string,
  companyName: string = economyConfig.DEFAULT_COMPANY_NAME
): Player {
  return {
    id,
    companyName,
    cash: economyConfig.STARTING_CASH,
    companyValue: economyConfig.STARTING_CASH,
    totalRevenue: 0,
    totalExpense: 0,
    totalProfit: 0,
    reputation: economyConfig.STARTING_REPUTATION,
    parkingLotIds: [],
    marketShare: 0,
    loans: [],
    researchPoints: 0,
  };
}
